<template>
	<div>
	    <div v-if="items.length" class="chooser">
	    	<div class="row middle">
	    		<div class="col-lg-6">
	    			{{ label }}
	    		</div>
	    		<div class="col-lg-6">
	    			<input type="text" v-model="search" :placeholder="$t('label.search')">
	    		</div>
	    	</div>
	        <div class="chooser-scroll">
	        	<div class="row chooser-row" v-for="item in filteredItems">
	                <div class="col-lg-12">
	                  <label class="checkbox-label">
	                      <span class="checkbox-label-marker">
	                          <input type="checkbox" :value="item" v-model="checkedItems" />
	                          <span class="checkbox-label-flag"></span>
	                      </span>
	                      <span class="checkbox-label-text">
	                        <span>{{ item.name }}</span> <span>{{ item.price }} {{ currency }}</span>
	                      </span>
	                  </label>
	                </div>
	            </div>
	        </div>
	    </div>
	    <slot v-else></slot>
    </div>
</template>

<script>
  import auth from '@/auth'
  import _ from 'lodash'
  export default {
    name: 'ChooserWidget',
    props: ['value', 'url', 'label'],
    created () {
      this.load()
    },
    mounted () {
      if (this.value) {
        this.checkedItems = this.value
      }
    },
    data () {
      return {
        items: [],
        checkedItems: [],
        initial: true,
        search: null,
        currency: auth.getOrganization().currency.toUpperCase()
      }
    },
    watch: {
      checkedItems () {
        this.$emit('input', this.checkedItems)
      }
    },
    computed: {
      filteredItems () {
        let scope = this
        if (this.initial) {
          this.items = _.orderBy(this.items, [
            function (item) {
              return _.find(scope.checkedItems, function (single) { return single.id === item.id })
            }, 'name'], ['asc', 'asc'])

          this.initial = false
        }
        return this.items.filter((item) => {
          if (!this.search) {
            return true
          }
          return item['name'].toLowerCase().includes(this.search.toLowerCase())
        })
      }
    },
    methods: {
      load () {
        this.$api.get(this.url).then(response => {
          this.items = response.data.data
          this.items = _.orderBy(this.items, ['name'], ['asc'])
        })
      },
      toggle (key) {
        this.items[key].active = !this.items[key].active
        this.$emit('input', this.getActiveItems())
      },
      clear () {
        this.checkedItems = []
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/widgets/ChooserWidget.vue